module.exports = __webpack_public_path__ + "static/img/odds_maker_Icon.da8bfea.png";